import { render, staticRenderFns } from "./AverageExpense.vue?vue&type=template&id=520a66f6&lang=pug&"
import script from "./AverageExpense.vue?vue&type=script&lang=ts&"
export * from "./AverageExpense.vue?vue&type=script&lang=ts&"
import style0 from "./AverageExpense.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports